import React, {useState} from 'react';
import { BrowserRouter as Router, Route, Link, Switch} from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import { createMuiTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import PrivacyPolicy from './PrivacyPolicy';
import { ErrorPage } from './ErrorPage';
import { Footer } from './Footer';
import { Contact } from './Contact';
import { useTranslation } from 'react-i18next';
import i18n from './i18n'
import { ButtonGroup } from '@material-ui/core';




const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
}));

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#7ebeab"
    },
    secondary: {
      main: "#ffffff"
    }
  }
});



function TemporaryDrawer() {
  const [open, setopen] = useState(false);
  const toggleOpen=() => {
      setopen(!open);
  }
  const {t, i18n} = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const list = (anchor) => (
    <div
      role="presentation"
      onClick={toggleOpen}
      onKeyDown={toggleOpen}
    >
      {/* <List>
      <ListItem button key='Top' component={Link} to='/'>
            <ListItemText>• {t('Top')}</ListItemText>
      </ListItem>
      <ListItem button key='Help' component={Link} to='/Help'>
            <ListItemText>• {t('Help')}</ListItemText>
      </ListItem>
      </List>
      <Divider /> */}
      <List>
      <ListItem button key='PrivacyPolicy' component={Link} to='/'>
            <ListItemText>• {t('Privacy Policy')}</ListItemText>
      </ListItem>
      <ListItem button key='Contact' component={Link} to='/Contact'>
            <ListItemText>• {t('Contact')}</ListItemText>
      </ListItem>
      </List>
    </div>
  );

  return(
      <>
          <Button onClick={toggleOpen} color="secondary"><MenuIcon /></Button>
          <SwipeableDrawer
            anchor='left'
            open={open}
            onClose={toggleOpen}
            onOpen={toggleOpen}
          >
            {list('left')}
          </SwipeableDrawer>
      </>
  );
}

export default function MainPage() {
  const classes = useStyles();
  const {t, i18n} = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <ThemeProvider theme={theme}>
    <Router>
    <div className={classes.root}>
      <AppBar position="static"　color="primary">
        <Toolbar>
          <IconButton edge="start" className={classes.menuButton} color="secondary" aria-label="menu">
            <TemporaryDrawer/>
          </IconButton>
          <Typography　color="secondary" variant="h6" className={classes.title}>
            QR/Barcode
          </Typography>
          <ButtonGroup color="secondary" aria-label="outlined primary button group">
            <Button onClick={() => changeLanguage('en')}>en</Button>
            <Button onClick={() => changeLanguage('ja')}>jp</Button>
          </ButtonGroup>
        </Toolbar>
      </AppBar>
      <Switch>
        {/* <Route exact path='/'>
          <Home />
        </Route> */}
        {/* <Route exact path='/Help'>
          <Help />
        </Route> */} 
        <Route exact path='/'>
          <PrivacyPolicy />
        </Route>
        <Route exact path='/Contact'>
          <Contact />
        </Route>
        <Route>
          <ErrorPage />
        </Route>
      </Switch>
      </div>
      </Router>
      <Footer/>
    </ThemeProvider> 
  );
}